var _style, _path, _g, _g2, _polygon, _polygon2, _path2, _path3, _circle, _path4, _path5, _path6, _g3, _g4, _g5, _g6, _g7, _g8, _path7, _path8, _g9, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 584 440",
    style: {
      enableBackground: "new 0 0 584 440"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFB6B6;}\n\t.st2{fill:#2F2E41;}\n\t.st3{fill:#3F3D56;}\n\t.st4{fill:#FB3640;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#E6E6E6;}\n\t.st7{fill:none;}\n\t.st8{fill:#483E37;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.1,440H390.9c-7.1,0-12.9-5.8-12.9-12.9V116.9c0-7.1,5.8-12.9,12.9-12.9h124.1c7.1,0,12.9,5.8,12.9,12.9 v310.1C528,434.2,522.2,440,515.1,440z M390.9,106c-6,0-10.9,4.9-10.9,10.9v310.1c0,6,4.9,10.9,10.9,10.9h124.1 c6,0,10.9-4.9,10.9-10.9V116.9c0-6-4.9-10.9-10.9-10.9L390.9,106L390.9,106z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "478.5,429.6 470.5,429.6 466.7,398.8 478.5,398.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.8,437.9l-24.5,0v-0.3c0-5.3,4.3-9.5,9.5-9.5h0l4.5-3.4l8.4,3.4l2.1,0L478.8,437.9L478.8,437.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "439.1,429.6 431.2,429.6 427.4,398.8 439.1,398.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,437.9l-24.5,0v-0.3c0-5.3,4.3-9.5,9.5-9.5h0l4.5-3.4l8.4,3.4l2.1,0L439.4,437.9L439.4,437.9z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "443.4,255.5 497.5,253 502.9,284.5 499.4,295.3 496.5,307.6 487.6,350.9 480.2,414.8 464.6,414.8  464.3,354.1 467.9,349.1 467.9,345.7 465.4,301.5 449,344.3 450.5,350.2 446.1,361 440.7,414.8 426.1,414.8 422.9,341.3  434.7,296.1 434.7,287.7 436.7,283.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "479,154.4 459.3,154.4 456.9,165.2 437.7,174.1 444.6,224.2 440.7,240.5 440.7,246.9 438.7,252.8  437.7,271.6 505.1,276.4 500.7,266.5 502.1,260.6 500.7,257.2 496.7,228.2 499.7,172.1 484.4,166.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.2,247.6l14.1-11.7l7.8,7.1l-15.4,11.9c-0.1,0.6-0.3,1.2-0.6,1.7c-1.6,3-5.3,4.2-8.3,2.6s-4.2-5.3-2.6-8.3 C373.3,248.9,375.2,247.8,377.2,247.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M450.2,178.1l-7.5-3c-2.3-1.4-5.3-1.1-7.3,0.8c-3.8,3.6-9.3,9.5-9.8,14c0,0-17.9,18.6-18.2,22.1 s-24.8,30-24.8,30l11.4,8.5l46.3-44.3l4.2-22.4C446.5,180.8,453.2,179.9,450.2,178.1L450.2,178.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 469.9,
    cy: 135.8,
    r: 16.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487.9,143.8c-0.4-0.5-0.6-1.1-0.9-1.6c0,0.8,0,1.6,0.1,2.4c0,0.1,0,0.3,0.1,0.5c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1 c-1.2,2.2-2.5,3.6-3.5,4c-2.4,1-5.7,1.8-5.9,2c0.2-0.4,8.8-13.8,5.9-14.8c-3-1-2.7,0.8-2.7,0.8c-1.3-5.5-4-7.8-8.1-6.8 c-5.3-0.2-10.5-1.8-13.2,3.8c-0.3-1.3-0.8-2.6-1.3-3.7c-0.1,1.2-0.1,2.6-0.5,3.8c-3.8,3.3-6,2.7-7.5,0.6c0-0.4,0-0.9,0-1.3 c0-0.3,0.1-0.6,0.1-0.8c0.2-0.8,0.8-1.3,1.1-2c-0.7,0.4-1.4,0.7-2,1.2c-0.1,0.1-0.2,0.2-0.4,0.3c-0.4-2.6-1.7-11.1,2.5-8.2s2-3,2-3 h5.1c0,0,0.9-1.2,2.4-2.4c0.3,0.1,0.5,0.2,0.8,0.3c0.8,0.3-1.7-2.5-1.1-2.1c-0.2-0.7,2.3,2,2,1.3c-0.1-0.1,0.1-2.1,0-2.3 c2.9-1.7,16.6-1.7,21,2c5.6,4.7-1.5,2.3,5.6,11.5C492.4,133.2,492.2,136.7,487.9,143.8L487.9,143.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.1,440H64.9c-7.1,0-12.9-5.8-12.9-12.9V116.9c0-7.1,5.8-12.9,12.9-12.9h283.1c7.1,0,12.9,5.8,12.9,12.9 v310.1C361,434.2,355.2,440,348.1,440z M137.9,106C91.6,106,54,143.6,54,189.9v237.1c0,6,4.9,10.9,10.9,10.9h283.1 c6,0,10.9-4.9,10.9-10.9V116.9c0-6-4.9-10.9-10.9-10.9C348.1,106,137.9,106,137.9,106z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.9,0H13.1C5.9,0,0,5.9,0,13.1v186.8c0,6.9,5.4,12.6,12.2,13.1c0.3,0,0.6,0,0.9,0h39.1v-2H13.1 c-0.3,0-0.6,0-0.9,0C6.5,210.5,2,205.7,2,199.9V13.1C2,7,7,2,13.1,2h557.8C577,2,582,7,582,13.1v186.8c0,6.1-5,11.1-11.1,11.1h-44.7 v2h44.7c7.2,0,13.1-5.9,13.1-13.1V13.1C584,5.9,578.1,0,570.9,0z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.1,130.7H173c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h67.1c2.3,0,4.2,1.9,4.2,4.2S242.4,130.7,240.1,130.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.5,144.8H173c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h119.4c2.3,0,4.2,1.9,4.2,4.2 S294.8,144.8,292.5,144.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 140,
    cy: 52,
    rx: 12.5,
    ry: 12.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.9,47.8h-67.1c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h67.1c2.3,0,4.2,1.9,4.2,4.2S242.2,47.8,239.9,47.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.2,61.9H172.8c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h119.4c2.3,0,4.2,1.9,4.2,4.2S294.5,61.9,292.2,61.9 z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 259.7,
    cy: 164.3,
    r: 9.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 259.7,
    cy: 164.3,
    rx: 6.5,
    ry: 6.3
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75.7,
    cy: 237.8,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 75.7,
    cy: 237.8,
    rx: 8.5,
    ry: 8.3
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 336.1,
    cy: 343.6,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 336.1,
    cy: 343.6,
    rx: 8.5,
    ry: 8.3
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 152.4,
    cy: 418.2,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 152.4,
    cy: 418.2,
    rx: 8.5,
    ry: 8.3
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.7,226l18-3.9l3.6,10l-19.1,3.4c-0.4,0.5-0.8,0.9-1.3,1.2c-2.8,1.9-6.6,1.2-8.6-1.6 c-1.9-2.8-1.2-6.6,1.6-8.6C440.6,225.4,442.8,225.3,444.7,226L444.7,226z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M498.9,172.8L498.9,172.8c4.3-1,8.6,1.4,10,5.6c2.2,6.5,4.5,16,2.1,22.3l-2,16.2l-2.5,8.9v1.3l-52.6,7.6 l-2.5-12.8l33.9-5.4l1-5.9l0.9-0.9l1.3-6.7l3.8-23.1C492.9,176.3,495.5,173.6,498.9,172.8L498.9,172.8z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 139.9,
    cy: 133.9,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.9,145.1c-6.2,0-11.2-5-11.2-11.2s5-11.2,11.2-11.2s11.2,5,11.2,11.2S146.1,145.1,139.9,145.1z  M139.9,123.8c-5.6,0-10.1,4.5-10.1,10.1s4.5,10.1,10.1,10.1s10.1-4.5,10.1-10.1S145.4,123.8,139.9,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.4,139.4c-0.4,0-0.7-0.2-0.9-0.5l-2.9-3.8c-0.4-0.5-0.3-1.3,0.2-1.6c0.5-0.4,1.3-0.3,1.6,0.2l1.9,2.5 l4.8-7.2c0.4-0.5,1.1-0.7,1.6-0.3c0.5,0.4,0.7,1.1,0.3,1.6l-5.7,8.6C139.2,139.1,138.8,139.3,138.4,139.4L138.4,139.4L138.4,139.4z "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M411.4,78.5c-1.2-6.4-4.6-12.4-9.4-16.8c-4.7-4.3-10.8-7-17.1-7.7c-3.5-0.4-7.1-0.2-10.6,0.7 c-0.8,0.2-0.7,1.5,0.2,1.3c5.9-1.5,12.1-1.1,17.8,1.1c5.8,2.3,10.7,6.4,13.9,11.6c1.9,3,3.2,6.4,3.9,9.8 C410.3,79.5,411.6,79.4,411.4,78.5L411.4,78.5L411.4,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M375.3,49.2l-9.7,6.1c-0.4,0.2-0.4,0.8,0,1.1l10.5,7c0.7,0.5,1.5-0.6,0.8-1.1l-10.5-7l0,1.1l9.7-6.1 C376.8,49.8,376,48.8,375.3,49.2C375.3,49.2,375.3,49.2,375.3,49.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.8,243.2c-5.1,11.8-14.3,21.1-26.1,26.1l-16.8-6.9c15.8-7.6,28.4-20.1,36-36L184.8,243.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M232,225.1l-7,16.8c-11.9,4.8-25,4.8-37,0l-7-16.8c8.3,2.9,16.8,4.4,25.4,4.4C215.2,229.5,223.8,228,232,225.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M271.3,262.4l-16.8,6.9c-11.8-5.1-21.1-14.3-26.1-26.1l7-16.8C242.9,242.3,255.4,254.9,271.3,262.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.6,316.6l-16.8-7c-4.8-12-4.8-25,0-37l16.8-7C266.8,282.2,266.8,300,272.6,316.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M232,357.2c-16.5-5.9-34.3-5.9-50.9,0l7-16.8c12-4.8,25-4.8,37,0L232,357.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M157.3,309.6l-16.8,7c5.9-16.5,5.9-34.3,0-50.9l16.8,7C162.1,284.6,162.1,297.7,157.3,309.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M271.3,319.8c-15.8,7.6-28.4,20.1-36,36l-7-16.8c5.1-11.8,14.3-21.1,26.1-26.2L271.3,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.8,339.1l-7,16.8c-7.6-15.8-20.1-28.4-36-36l16.8-7C170.5,318,179.7,327.2,184.8,339.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M315.2,334.2l-16.8-6.9c-9.5-23.3-9.5-48.9,0-72.2l16.8-6.9C304.7,276,304.7,306.3,315.2,334.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167.2,200.7c-9.8,23.2-27.9,41.3-51.1,51.1l-16.8-6.9c27.2-12.3,48.6-33.7,60.9-60.9L167.2,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.8,244.8l-16.8,6.9c-23.2-9.8-41.3-27.9-51.1-51.1l7-16.8C265.2,211.1,286.6,232.5,313.8,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M249.6,182.6l-7,16.8c-23.3,9.5-48.9,9.5-72.2,0l-7-16.8c14,5.2,28.5,7.9,43.1,7.9 C221.1,190.5,235.7,187.8,249.6,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167.2,381.6l-7,16.7c-12.3-27.2-33.7-48.6-60.9-60.9l16.8-6.9C139.3,340.3,157.4,358.4,167.2,381.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.7,327.3L98,334.2c10.5-27.9,10.5-58.2,0-86.1l16.8,6.9C124.2,278.3,124.2,303.9,114.7,327.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M293.9,325.4l-16.8-6.9c-7.1-17.6-7.1-37,0-54.6l16.8-6.9C285.7,279.1,285.7,303.1,293.9,325.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.8,337.5c-27.2,12.3-48.6,33.7-60.9,60.9l-7-16.7c9.8-23.2,27.9-41.3,51.1-51.1L313.8,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M249.6,399.7c-27.9-10.5-58.2-10.5-86.1,0l7-16.8c23.3-9.5,48.9-9.5,72.2,0L249.6,399.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M292.5,253.6l-16.8,6.9c-17.5-7.4-31.2-21.1-38.6-38.6l7-16.8C254.1,226.7,271,243.7,292.5,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176,221.9c-7.4,17.5-21.1,31.2-38.6,38.6l-16.8-6.9c21.5-9.9,38.5-26.9,48.4-48.4L176,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M240.8,203.8l-7,16.8c-17.6,7.1-37,7.1-54.6,0l-7-16.8c11.1,4.1,22.7,6.1,34.2,6.1 C218.1,210,229.7,207.9,240.8,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M136,318.4l-16.8,6.9c8.2-22.2,8.2-46.3,0-68.5l16.8,6.9C143.1,281.5,143.1,300.8,136,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M240.8,378.4c-22.2-8.2-46.3-8.2-68.5,0l7-16.8c17.6-7.1,37-7.1,54.6,0L240.8,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176,360.3l-7,16.8c-9.9-21.5-26.9-38.5-48.4-48.4l16.8-6.9C154.9,329.2,168.6,342.8,176,360.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M292.5,328.7c-21.5,9.9-38.5,26.9-48.4,48.4l-7-16.8c7.4-17.5,21.1-31.2,38.6-38.6L292.5,328.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.2,338.4l-5.5-2.3c-11.8-29-11.8-60.9,0-89.9l5.5-2.3c0.9-0.4,1.3-1.4,1-2.3c-0.4-0.9-1.4-1.3-2.3-1 l-5.6,2.3c-28.9-12.1-51.4-34.7-63.5-63.5l2.3-5.5c0.4-0.9-0.1-2-1-2.3c-0.9-0.4-2,0.1-2.3,1l-2.3,5.6c-29,11.8-60.9,11.8-89.9,0 l-2.3-5.6c-0.4-0.9-1.4-1.3-2.3-1c-0.9,0.4-1.3,1.4-1,2.3l2.3,5.5c-12.1,28.9-34.7,51.4-63.5,63.5l-5.6-2.3c-0.9-0.4-1.9,0.1-2.3,1 c-0.4,0.9,0.1,1.9,1,2.3l5.5,2.3c11.8,29,11.8,60.9,0,89.9l-5.5,2.3c-0.9,0.4-1.3,1.4-1,2.3c0.3,0.7,0.9,1.1,1.6,1.1 c0.2,0,0.5-0.1,0.7-0.1l5.6-2.3c28.9,12.1,51.4,34.7,63.5,63.5l-2.3,5.5c-0.4,0.9,0.1,2,1,2.3c0.2,0.1,0.5,0.1,0.7,0.1 c0.7,0,1.3-0.4,1.6-1.1l2.3-5.6c29-11.8,60.9-11.8,89.9,0l2.3,5.6c0.3,0.7,0.9,1.1,1.6,1.1c0.2,0,0.5,0,0.7-0.1 c0.9-0.4,1.3-1.4,1-2.3l-2.3-5.5c12.1-28.9,34.7-51.4,63.5-63.5l5.6,2.3c0.2,0.1,0.4,0.1,0.7,0.1c0.7,0,1.3-0.4,1.6-1.1 C326.6,339.8,326.1,338.7,325.2,338.4z M252.9,183.9c12.3,27.2,33.7,48.6,60.9,60.9l-16.8,6.9c-23.2-9.8-41.3-27.9-51.1-51.1 L252.9,183.9z M228.3,243.2l7-16.8c7.6,15.8,20.1,28.4,36,36l-16.8,6.9C242.7,264.3,233.4,255.1,228.3,243.2z M225.1,241.9 c-11.9,4.8-25,4.8-37,0l-7-16.8c8.3,2.9,16.8,4.4,25.4,4.4c8.6,0,17.2-1.5,25.4-4.4L225.1,241.9z M184.8,243.2 c-5.1,11.8-14.3,21.1-26.1,26.1l-16.8-6.9c15.8-7.6,28.4-20.1,36-36L184.8,243.2z M157.3,272.6c4.8,12,4.8,25,0,37l-16.8,7 c5.9-16.5,5.9-34.3,0-50.9L157.3,272.6z M158.7,312.9c11.8,5.1,21.1,14.3,26.1,26.2l-7,16.8c-7.6-15.8-20.1-28.4-36-36L158.7,312.9 z M188.1,340.4c12-4.8,25-4.8,37,0l7,16.8c-16.5-5.9-34.3-5.9-50.9,0L188.1,340.4z M228.3,339.1c5.1-11.8,14.3-21.1,26.1-26.2 l16.8,7c-15.8,7.6-28.4,20.1-36,36L228.3,339.1z M255.9,309.6c-4.8-12-4.8-25,0-37l16.8-7c-5.9,16.5-5.9,34.3,0,50.9L255.9,309.6z  M237.2,221.9l7-16.8c9.9,21.5,26.9,38.5,48.4,48.4l-16.8,6.9C258.3,253.1,244.6,239.4,237.2,221.9z M233.9,220.6 c-17.6,7.1-37,7.1-54.6,0l-7-16.8c11.1,4.1,22.7,6.1,34.2,6.1c11.6,0,23.1-2.1,34.2-6.1L233.9,220.6z M176,221.9 c-7.4,17.5-21.1,31.2-38.6,38.6l-16.8-6.9c21.5-9.9,38.5-26.9,48.4-48.4L176,221.9z M136,263.8c7.1,17.6,7.1,37,0,54.6l-16.8,6.9 c8.2-22.2,8.2-46.3,0-68.5L136,263.8z M137.4,321.7c17.5,7.4,31.2,21.1,38.6,38.6l-7,16.8c-9.9-21.5-26.9-38.5-48.4-48.4 L137.4,321.7z M179.3,361.7c17.6-7.1,37-7.1,54.6,0l7,16.8c-22.2-8.2-46.3-8.2-68.5,0L179.3,361.7z M237.2,360.3 c7.4-17.5,21.1-31.2,38.6-38.6l16.8,6.9c-21.5,9.9-38.5,26.9-48.4,48.4L237.2,360.3z M277.1,318.4c-7.1-17.6-7.1-37,0-54.6 l16.8-6.9c-8.2,22.2-8.2,46.2,0,68.5L277.1,318.4z M206.6,190.5c14.5,0,29.1-2.7,43.1-7.9l-7,16.8c-23.3,9.5-48.9,9.5-72.2,0 l-7-16.8C177.5,187.8,192,190.5,206.6,190.5z M160.2,183.9l7,16.8c-9.8,23.2-27.9,41.3-51.1,51.1l-16.8-6.9 C126.5,232.5,147.9,211.1,160.2,183.9z M98,248.1l16.8,6.9c9.5,23.3,9.5,48.9,0,72.2L98,334.2C108.5,306.3,108.5,276,98,248.1z  M160.2,398.4c-12.3-27.2-33.7-48.6-60.9-60.9l16.8-6.9c23.2,9.8,41.3,27.9,51.1,51.1L160.2,398.4z M163.5,399.7l7-16.8 c23.3-9.5,48.9-9.5,72.2,0l7,16.8C221.7,389.2,191.5,389.2,163.5,399.7z M252.9,398.4l-7-16.7c9.8-23.2,27.9-41.3,51.1-51.1 l16.8,6.9C286.6,349.8,265.2,371.2,252.9,398.4z M298.4,327.3c-9.5-23.3-9.5-48.9,0-72.2l16.8-6.9c-10.5,27.9-10.5,58.2,0,86.1 L298.4,327.3z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path915",
    className: "st4",
    d: "M206.5,252.1c-3,0-6,3.3-17.5,10c-0.5,0.3-0.9,0.5-1.3,0.7l18,22.4l18.7-23L224,262 C212.5,255.4,209.5,252.1,206.5,252.1z M205.7,265.6c2.9,0,5.2,2.3,5.2,5.2l0,0l0,0c0,2.9-2.3,5.2-5.2,5.2s-5.2-2.3-5.2-5.2 S202.8,265.6,205.7,265.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path913",
    className: "st4",
    d: "M228,264.2l-19.7,24.2l3.7,4.7l16.6-16.5l11.8,23.6l1.5,3.7c-0.2-2.8-0.4-6.6-0.4-11.7 C241.4,267.3,246.3,274.2,228,264.2L228,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path911",
    className: "st4",
    d: "M184.1,264.8c-17.2,9.3-12.6,3.1-12.5,27.6c0,2.7,0,4.9-0.1,6.9l11.4-23.1l16.5,16.8l3.7-4.5 L184.1,264.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path907",
    className: "st8",
    d: "M184,283.1l-9.1,18.5l-3.8,6.4c-0.2,7.3,1.9,5.3,18.1,14.6c23,13.2,12,13.3,34.9-0.1 c13.2-7.6,17-7.7,17.8-11.4c-1.7-3-3.4-6-5.1-9.1l-9.3-18.6l-12.9,12.9l4.9,6.1l-13.8,13.8l-13.8-13.9l5-6.2L184,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path905",
    className: "st4",
    d: "M205.7,291.7l-3.4,4.2l3.4,3.5l3.4-3.4L205.7,291.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4587",
    className: "st4",
    d: "M199.7,299l-2.4,3l8.4,8.5l8.4-8.4l-2.4-3l-5.9,5.9L199.7,299z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.8,262.5h-20.8c-2.4,0-4.4-1.7-4.7-4.1c-1.3-9.5-1.3-19.1,0-28.5c0.3-2.3,2.3-4,4.6-4.1 c6.6-2.9,13.6-2.9,21,0c1.4,0,2.7,0.7,3.6,1.7c0.9,1.1,1.3,2.6,1,4c-1.7,8.3-1.7,16.9,0,25.2c0.3,1.4-0.1,2.9-1,4 C355.5,261.9,354.2,262.5,352.8,262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M350.6,236.7H333c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h17.5c0.6,0,1.1,0.5,1.1,1.1S351.2,236.7,350.6,236.7 L350.6,236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M350.6,245.5H333c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h17.5c0.6,0,1.1,0.5,1.1,1.1 C351.7,245,351.2,245.5,350.6,245.5L350.6,245.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M350.6,254.2H333c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h17.5c0.6,0,1.1,0.5,1.1,1.1 C351.7,253.7,351.2,254.2,350.6,254.2L350.6,254.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6eced2d1317a392e50affc28f68314a0.svg";
export { ForwardRef as ReactComponent };